<template>
  <div>
    <div
      style="
        position: fixed;
        top: 20px;
        z-index: 500;
        backdrop-filter: blur(2px);
      "
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="dashboardAdmin-parentdiv bluebtn">
      <div class="dashboardAdmin-header mt-4">
        <div class="dashboardAdmin-header-main-head d-flex">
          <img
            src="../../../assets/New-imgs/interviewProcess-icons/newInt-backBtn-arrow.svg"
            alt=""
            class="mr-3 pointer"
            @click="gobackpointer"
          />
          <span>
            {{ $route.name == "EditCustomer" ? "Edit" : "Activate" }}
            Customer</span
          >
        </div>
      </div>
      <div
        class="
          mt-3
          teams-main-container
          custField-main-height
          relativeclass
          forminputs
          w-100
          p-0
        "
      >
        <div class="h-100">
          <div
            style="
              height: 90%;
              overflow-x: hidden;
              overflow-y: auto;
              padding: 35px 200px;
            "
          >
            <div class="newMan-head-font">Select Customer Type</div>
            <div class="mt-1 newMan-subhead-font">
              To specify the entity's role, select either 'Internal Department'
              or 'Client Hiring'
            </div>
            <div class="mt-4 d-flex align-items-center">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <div>
                    <b-form-radio
                      v-model="parentID"
                      value="2"
                      class="manage-radio-disabled-main"
                      @change="atCustomerChangeType()"
                      disabled
                      >Internal Department</b-form-radio
                    >
                  </div>
                  <div>
                    <b-form-radio
                      class="ml-4 manage-radio-disabled-main"
                      v-model="parentID"
                      value="3"
                      @change="atCustomerChangeType()"
                      disabled
                      >Client Hiring</b-form-radio
                    >
                  </div>
                </div>
              </b-form-group>
            </div>
            <hr class="mb-0" />
            <FormShimmer v-if="shimmerLoader" />
            <template v-else>
              <div class="newMan-inner-container">
                <b-row>
                  <b-col
                    v-for="(field, index) in customFieldsArray"
                    :key="index"
                    :cols="getColumn(field.controlType)"
                    class="relativeclass mt-2"
                    :class="
                      field.controlType == 'boolean'
                        ? 'd-flex align-items-center'
                        : ''
                    "
                  >
                    <div
                      v-if="
                        field.controlType == 'text' ||
                        field.controlType == 'email' ||
                        field.controlType == 'number'
                      "
                      class="topDiv mt-3"
                    >
                      <InputField
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        @handle-input="handleInput(field)"
                        @handle-blur="handleBlur(field)"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>

                    <div
                      v-else-if="field.controlType == 'single_select'"
                      class="topDiv mt-3"
                    >
                      <SelectCustom
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        :api="field.apiEndpoint"
                        :values="field.values"
                        :dropdown="field.dropdown"
                        :fieldType="field.fieldType"
                        @select-value="updateFieldValue(field, $event)"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>

                    <div
                      v-else-if="field.controlType == 'multi_select'"
                      class="topDiv mt-3"
                    >
                      <MultiSelectCustom
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        :api="field.apiEndpoint"
                        :values="field.values"
                        :dropdown="field.dropdown"
                        :fieldType="field.fieldType"
                        @select-value="updateFieldValue(field, $event)"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>
                    <div
                      v-else-if="field.controlType == 'rich_text_box'"
                      class="topDiv mt-3"
                    >
                      <CustomQuillEditor
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        @handle-input="handleInput(field)"
                        @handle-blur="handleBlur(field)"
                        :limit="parseInt(field.limit)"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>

                    <div
                      v-else-if="field.controlType == 'boolean'"
                      class="topDiv mt-4"
                    >
                      <SwitchBox
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>

                    <div
                      v-else-if="field.controlType == 'upload_file'"
                      class="topDiv mt-3"
                    >
                      <UploadDocument
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        :fileFormat="field.fileFormat"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                        @reupload-value="field.isReupload = true"
                        :maxFileSize="field.maxFileSize"
                      />
                    </div>
                    <div
                      v-else-if="field.controlType == 'multi_text'"
                      class="topDiv mt-3"
                    >
                      <FormTags
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                        @handle-input="handleInput(field)"
                        @handle-blur="handleBlur(field)"
                      />
                    </div>
                    <div
                      v-else-if="field.controlType == 'date'"
                      class="topDiv mt-3"
                    >
                      <DateField
                        :type="field.controlType"
                        :label="field.label"
                        :mandatory="field.mandatory"
                        :placeholder="field.placeholder"
                        :id="field.key"
                        @select-value="updateFieldValue(field, $event)"
                        :format="field.dateTimeFormat"
                        :showError="getError(field)"
                        :vmodel="getVmodel(field)"
                      />
                    </div>
                    <template v-if="touchedFields[field.key]">
                      <div
                        class="newInt-required-validation-font mt-1"
                        v-if="field.mandatory && !validateField(field)"
                      >
                        {{ valText[field.key] }}
                      </div>
                      <div
                        class="newInt-required-validation-font mt-1"
                        v-else-if="field.limit > 0 && !validateField(field)"
                      >
                        {{ valText[field.key] }}
                      </div>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>
          <div
            style="height: 10%"
            class="
              newInt-footer
              d-flex
              align-items-center
              justify-content-end
              w-100
              bluebtn
            "
          >
            <b-button class="acs-cancelBtn-modal mr-3" @click="gobackpointer"
              >Cancel</b-button
            >
            <b-button class="acs-addBtn-modal" @click="validateForm()">
              {{ $route.name == "EditCustomer" ? "Update" : "Activate" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toast from "../../../components/mixin/toast";
import customerData from "../../../components/mixin/customerMixin";
export default {
  name: "EditCustomer",
  mixins: [toast, customerData],
};
</script>
